import React from 'react';
import { PropTypes } from 'prop-types';

import { CarouselThemes } from '../../consts';

import { Cursors } from 'modules/ui';

const CarouselCursor = ({ styles, theme, carouselTheme }) => {
    const Icon = Cursors.CarouselCursor;

    const isDarkTheme = carouselTheme === CarouselThemes.DARK;

    const fill = isDarkTheme ? theme.colors.black : theme.colors.white;
    const stroke = isDarkTheme ? theme.colors.cyan : theme.colors.blue;

    return (
        <div className={styles.container}>
            <Icon fill={fill} stroke={stroke} />
        </div>
    );
};

CarouselCursor.propTypes = {
    styles: PropTypes.shape().isRequired,
    // eslint-disable-next-line
    cursorDirection: PropTypes.string.isRequired,
    carouselTheme: PropTypes.string,
    theme: PropTypes.shape().isRequired,
};

CarouselCursor.defaultProps = {
    carouselTheme: CarouselThemes.LIGHT,
};

export default CarouselCursor;
